import moment from "moment";
import { api, helpers } from "../../../../utils";
const { stored } = api.net.config;
const cafe = {
    format: {
        dateTime: "YYYY-MM-DD HH:mm:ss",
    },
    sms: {
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const hlog = helpers.html.log;

const loadList = async ({ rootState, commit }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload || !payload.ProjectID) return resolve({ error: cafe.sms.invalid_inputs });
        const { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        const { SessionID } = headers;
        const { ProjectID } = payload;
        let filter = { SessionID, ProjectID };
        hlog.start("store.link.ranking.list", "start", filter);
        const res_keywords = await api.net.data.bot.load.list({ storeName: stored.link.ranking.GetKeywordSearch, filter });
        let isNotValid = !res_keywords || !res_keywords.isSuccess || !Array.isArray(res_keywords.data);
        if (isNotValid) return resolve({ error: res_keywords.error });
        let data = handleDataList({ data: res_keywords.data });
        hlog.end("store.link.ranking.list", "end", data);
        commit({ type: "loadData", data });
        resolve({ isSuccess: true, data });
    });

    return p;
};

const updateList = async ({ rootState, commit }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload || !payload.ProjectID || !Array.isArray(payload.tKeywordList)) return resolve({ error: cafe.sms.invalid_inputs });
        const { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        let text = "store.link.ranking.update";
        const { SessionID } = headers;
        const { ProjectID, tKeywordList } = payload;
        let filter = { SessionID, ProjectID, tKeywordList };
        hlog.start(text, "start", filter);
        const storeName = stored.seo.ranking.UpdateKeywordList;
        const res_update = await api.net.data.seo.load.list({ storeName, filter });
        hlog.end(text, "end", res_update);
        let isNotValid = !res_update || !res_update.isSuccess || !Array.isArray(res_update.data);
        if (isNotValid) return resolve({ error: res_update.error });
        let data = handleDataList({ data: res_update.data });
        hlog.end(text, "end", data);
        commit({ type: "loadData", data });
        resolve({ isSuccess: true, data });
    });

    return p;
};

const handleDataList = ({ data }) => {
    let state = { list: [], obj: {} };
    if (!Array.isArray(data)) return state;
    let list = { keywords: data };
    for (let [i, item] of list.keywords.entries()) {
        item.KeywordID = item.KeywordID || `KW${i + 1}`;
        const { KeywordID } = item;
        let kw = handleDataDetail({ item });
        state.obj[KeywordID] = kw;
    };
    for (let KeywordID of Object.keys(state.obj)) {
        let obj = state.obj[KeywordID];
        state.list.push(obj);
    };

    return state;
};

const handleDataDetail = ({ item }) => {
    let { KeywordID, KeywordName } = item;
    let CreateDate = moment(item.CreateDate).format(cafe.format.date);
    let kw = { KeywordID, KeywordName, CreateDate };
    return kw;
};

export default {
    loadList,
    updateList,
};



// WEBPACK FOOTER //
// src/store/views/link/ranking/actions.js